import { Filters } from "../models/shipeezi.table";

export function filter<T>(array: T[], filters: Filters) {
  const filtersKeys = Object.getOwnPropertyNames(filters);

  if (filtersKeys && filtersKeys?.length > 0) {
    const arrayFiltered: T[] = array?.filter((value: any) => {
      const key = filtersKeys.find((key) => filters[key].includes(value[key]));

      if (key) return true;

      return false;
    });

    return arrayFiltered;
  }

  return array;
}
